<template>
    <div>
        <CCol sm="12">
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <div class="custom-bg-gradient-blue" style="width: 100%;color: #fff">
                    <CCol sm="12">
                        <CRow>
    
                            <CCol sm="12" md="7" lg="8">
                                <h3 class="custom-36px-600 mt-4">Hi, {{ user.name }}
                                </h3>
                                <p class="custom-16px-400 text-white text-left">{{ formattedDateTime }}</p>
                            </CCol>
                            <CCol sm="12" md="5" lg="4">
                                <h3 class="custom-18px-700 font-inter">Get Easy Access To Your <br /> Account Today</h3>
                                <p class="custom-14px-400">Download MYHR Apps today.</p>
                                <div class="d-flex">
                                    <img src="../assets/img/googleicon.png" style="max-width:100px" /><img src="../assets/img/appleicon.png" class="ml-2" style="max-width:100px" />
                                </div>
                            </CCol>
    
                        </CRow>
                    </CCol>
    
                </div>
    
                <CRow class="mt-2 m-0">
                    <CCol sm="8">
                        <CRow class="p-0">
                            <CCol sm="4" class="p-1">
                                <div class="custom-bg-gradient-red" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Leave Approved
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="4" class="p-1">
                                <div class="custom-bg-gradient-blue-white" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Claim Approved
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="4" class="p-1">
                                <div class="custom-bg-gradient-white-blue" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        OverTime Approved
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="4" class="p-1 mt-2">
                                <div class="custom-bg-gradient-purple" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Payroll Record
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="4" class="p-1 mt-2">
                                <div class="custom-bg-gradient-blue-shiny" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Payment Voucher
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
    
                        </CRow>
                        <CRow class="mt-2">
                            <CCol sm="6" class="p-1">
                                <CCard class="p-2 custom-border-radius-10px" style="border:none">
                                    <CRow class="w-100">
                                        <CCol sm="12">
                                            <CRow class="w-100">
                                                <CCol sm="12">
                                                    <h3 class="custom-16px-600">Announcement</h3>
                                                </CCol>
                                            </CRow>
    
                                            <CRow class="mt-2 p-2">
                                                <CCol sm="12" md="12" lg="4">
                                                    <div class="custom-input-app-form mt-3 text-center">
                                                        <CCol sm="12" class="m-0">
                                                            <p class="custom-12px-600 font-color-FFA600 m-0">Mon</p>
    
                                                            <p class="custom-12px-400 font-color-171717 m-0">10</p>
                                                        </CCol>
                                                    </div>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="8">
                                                    <CRow class="mt-3">
                                                        <CCol sm="10" class="p-2">
                                                            <h3 class="custom-16px-600 m-0">
                                                                Interview
                                                            </h3>
                                                            <h4 class="custom-14px-400 font-color-8F8F8F">9:00 am - 11:30 am</h4>
                                                        </CCol>
                                                        <CCol sm="2" class="mt-2">
                                                            <img src="../assets/img/3dot.png" style="max-width:24px" />
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="4">
                                                    <div class="custom-input-app-form mt-3 text-center">
                                                        <CCol sm="12" class="m-0">
                                                            <p class="custom-12px-600 font-color-FFA600 m-0">Mon</p>
    
                                                            <p class="custom-12px-400 font-color-171717 m-0">10</p>
                                                        </CCol>
                                                    </div>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="8">
                                                    <CRow class="mt-2">
                                                        <CCol sm="10" class="p-2">
                                                            <h3 class="custom-16px-600 m-0">
                                                                Interview
                                                            </h3>
                                                            <h4 class="custom-14px-400 font-color-8F8F8F">9:00 am - 11:30 am</h4>
                                                        </CCol>
                                                        <CCol sm="2" class="mt-2">
                                                            <img src="../assets/img/3dot.png" style="max-width:24px" />
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="4">
                                                    <div class="custom-input-app-form mt-3 text-center">
                                                        <CCol sm="12" class="m-0">
                                                            <p class="custom-12px-600 font-color-FFA600 m-0">Mon</p>
    
                                                            <p class="custom-12px-400 font-color-171717 m-0">10</p>
                                                        </CCol>
                                                    </div>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="8">
                                                    <CRow class="mt-2">
                                                        <CCol sm="10" class="p-2">
                                                            <h3 class="custom-16px-600 m-0">
                                                                Interview
                                                            </h3>
                                                            <h4 class="custom-14px-400 font-color-8F8F8F">9:00 am - 11:30 am</h4>
                                                        </CCol>
                                                        <CCol sm="2" class="mt-2">
                                                            <img src="../assets/img/3dot.png" style="max-width:24px" />
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="4">
                                                    <div class="custom-input-app-form mt-3 text-center">
                                                        <CCol sm="12" class="m-0">
                                                            <p class="custom-12px-600 font-color-FFA600 m-0">Mon</p>
    
                                                            <p class="custom-12px-400 font-color-171717 m-0">10</p>
                                                        </CCol>
                                                    </div>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="8">
                                                    <CRow class="mt-2">
                                                        <CCol sm="10" class="p-2">
                                                            <h3 class="custom-16px-600 m-0">
                                                                Interview
                                                            </h3>
                                                            <h4 class="custom-14px-400 font-color-8F8F8F">9:00 am - 11:30 am</h4>
                                                        </CCol>
                                                        <CCol sm="2" class="mt-2">
                                                            <img src="../assets/img/3dot.png" style="max-width:24px" />
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="4">
                                                    <div class="custom-input-app-form mt-3 text-center">
                                                        <CCol sm="12" class="m-0">
                                                            <p class="custom-12px-600 font-color-FFA600 m-0">Mon</p>
    
                                                            <p class="custom-12px-400 font-color-171717 m-0">10</p>
                                                        </CCol>
                                                    </div>
                                                </CCol>
                                                <CCol sm="12" md="12" lg="8">
                                                    <CRow class="mt-2">
                                                        <CCol sm="10" class="p-2">
                                                            <h3 class="custom-16px-600 m-0">
                                                                Interview
                                                            </h3>
                                                            <h4 class="custom-14px-400 font-color-8F8F8F">9:00 am - 11:30 am</h4>
                                                        </CCol>
                                                        <CCol sm="2" class="mt-2">
                                                            <img src="../assets/img/3dot.png" style="max-width:24px" />
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
    
    
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </CCard>
                            </CCol>
                            <CCol sm="6" class="p-1">
                                <CCard class="p-2 custom-border-radius-10px" style="border:none">
                                    <CRow class="w-100">
                                        <CCol sm="12">
                                            <CRow class="w-100">
                                                <CCol sm="10">
                                                    <h3 class="custom-16px-600">Who’s Off this week</h3>
                                                </CCol>
                                                <CCol sm="2">
                                                    <div class="text-right">
                                                    </div>
                                                </CCol>
                                            </CRow>
                                            <div v-if="Array.isArray(off) && off.length > 0">
    
                                            <CRow class="p-2" v-for="item in off" v-bind:key="item.id">
                                                <CCol sm="2">
                                                    <img src="../assets/icons/Avatar/Woman/1.png" style="max-width:40px" />
                                                </CCol>
                                                <CCol sm="12" md="12" lg="10">
                                                    <CRow>
                                                        <CCol sm="12">
                                                            <h3 class="custom-16px-500 m-0 font-inter font-color-171717 text-left">
                                                                {{ item.title }}
                                                            </h3>
                                                            <h4 class="custom-12px-400 font-color-8F8F8F">{{ item.start | moment("DD") }} - {{ item.end | moment("DD MMM YYYY") }}<img src="../assets/img/circlesmall.png" style="max-width:10px" class="m-2" />{{ item.position }}<img src="../assets/img/circlesmall.png"
                                                                    style="max-width:10px" class="m-2" /> {{ item.description }}</h4>
    
                                                            <h4 class="custom-12px-400 font-color-8F8F8F"></h4>
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
    
    
    
                                            </CRow>
                                        </div>
                                        <div v-else class="no-data-message">
    
        <div class="no-data-message">
            <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:50px;" />
            <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p> </div>
    
</div>
                                        </CCol>
                                    </CRow>
                                </CCard>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="4" class="p-1">
    
                        <!-- <CCard class="p-2 custom-border-radius-16px" style="border:none">
                            <h3 class="custom-16px-600">Clock In / Out</h3>
                            <CRow>
                                <CCol sm="1"> <img src="../assets/img/clock 2.png" style="max-width:20px" /></CCol>
                                <CCol sm="11">
                                    <h4 class="custom-12px-400 font-color-8F8F8F mt-1 text-left">
                                        Clock {{ formattedDate }}
                                    </h4>
                                </CCol>
                                <CCol sm="6" class="mt-2">
                                    <CCard class="p-2">
                                        <h4 class="custom-12px-400 font-color-8F8F8F mt-1 text-left">
                                            Clock In
                                        </h4>
                                        <h5 class="custom-12px-400 text-black text-left">{{ attendance.clockIn }}</h5>
                                    </CCard>
    
                                </CCol>
                                <CCol sm="6" class="mt-2">
                                    <CCard class="p-2">
                                        <h4 class="custom-12px-400 font-color-8F8F8F mt-1 text-left">
                                            Clock Out
                                        </h4>
                                        <h5 class="custom-12px-400 text-black text-left">{{ attendance.clockOut }}</h5>
                                    </CCard>
    
                                </CCol>
                                <CCol sm="12">
                                    <div class="text-center">
                                        <img src="../assets/img/lunch.png" style="max-width:30px;" />
                                        <h4 class="custom-12px-400 font-color-8F8F8F mt-1">
                                            Lunch Break
                                        </h4>
                                        <h4 class="custom-12px-400 font-color-8F8F8F mt-1">
                                            12:30pm - 01:30pm
                                        </h4>
                                    </div>
    
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                    <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white p-0" block @click="SubmitAttendanceClockIn">Clock In</CButton>
                                    <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white p-0" block @click="SubmitAttendanceClockOut">Clock Out</CButton>
                                </CCol>
                            </CRow>
                        </CCard>  -->
                      
                        <CCard class="p-2 custom-border-radius-16px" style="border:none">
                            <h3 class="custom-16px-600">Team Calendar</h3>
                            <div class="calendar">
                                <div class="calendar-header">
                                    <div class="day" v-for="day in days" :key="day.date" :class="{ 'current-day-name': isCurrentDay(day), 'selected-day-name': isSelectedDay(day) }" @click="selectDay(day)">
                                        <div class="date" :class="{
                          'current-date': isCurrentDay(day),
                          'selected-date': isSelectedDay(day),
                          'not-current-date': !isCurrentDay(day) && !isSelectedDay(day)
                        }">
                                            {{ day.date }}
                                        </div>
                                        <div class="day-name">{{ day.name }}</div>
                                    </div>
                                </div>
                                <div class="calendar-body">
                                    <div class="time-slot" v-for="time in timeSlots" :key="time">
                                        <div class="time">{{ time }}</div>
                                        <div class="events">
                                            <div v-for="event in filteredEvents.filter(e => e.time === time)" :key="event.description" class="event">
                                                {{ event.description }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCard>
    
                    </CCol>
                </CRow>
    
    
    
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'



export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,

    },

    data() {
        return {
            user: {},
            days: this.generateDays(),
            timeSlots: this.generateTimeSlots(),
            events: [
                { time: '9:00 am', description: 'Meeting Expat', startDate: '2024-08-05' },
                { time: '12:30 pm', description: 'Meeting Advancedcellnet', startDate: '2024-08-06' },
                { time: '01:30 pm', description: 'Interview', startDate: '2024-08-06' },
                // Add more events here
            ],
            selectedDate: null,

            off: [],

            formattedDate: "",
            attendance: {}


        }
    },
    created() {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        this.formattedDate = new Date().toLocaleDateString('en-GB', options);
    },
    computed: {
        filteredEvents() {
            const selectedDate = this.selectedDate || new Date().toISOString().split('T')[0];
            return this.events.filter(event => event.startDate === selectedDate);
        },
        formattedDateTime() {
            const now = new Date();
            const optionsDate = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
            const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: true };

            const datePart = now.toLocaleDateString('en-US', optionsDate);
            const timePart = now.toLocaleTimeString('en-US', optionsTime);

            return `It’s ${datePart}, ${timePart}`;
        }
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetListWhoOffThisWeek();
                await this.GetAttendance();


            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
        }

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        generateDays() {
            const days = [];
            const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
            const today = new Date();

            // Find the nearest Monday (or today if it's Monday)
            const firstDayOfWeek = new Date(today);
            firstDayOfWeek.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1));

            // Generate a full week
            for (let i = 0; i < 7; i++) {
                const date = new Date(firstDayOfWeek);
                date.setDate(firstDayOfWeek.getDate() + i);
                days.push({
                    date: date.getDate(),
                    name: dayNames[i], // Use index directly to get the correct day name
                    fullDate: date.toISOString().split('T')[0] // Add full date for comparison
                });
            }

            return days;
        },
        generateTimeSlots() {
            const times = [];
            let hour = 9;
            let minute = 0;
            const period = ['am', 'pm'];
            while (hour < 18) {
                const formattedTime = `${hour % 12 || 12}:${minute === 0 ? '00' : minute} ${period[Math.floor(hour / 12)]}`;
                times.push(formattedTime);
                minute += 30;
                if (minute === 60) {
                    minute = 0;
                    hour++;
                }
            }
            return times;
        },
        isCurrentDay(day) {
            const today = new Date().toISOString().split('T')[0];
            return day.fullDate === today;
        },
        isSelectedDay(day) {
            return day.fullDate === this.selectedDate;
        },
        selectDay(day) {
            this.selectedDate = day.fullDate;
        },
        async GetListWhoOffThisWeek() {
            try {
                const response = await this.$API.get(this.$GetListOffWeek, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.off = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetAttendance() {
            try {
                const response = await this.$API.get(this.$GetAttendanceByUserId, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.attendance = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        SubmitAttendanceClockIn() {
            const formData = new FormData();
    const currentDateTime = new Date().toISOString(); // Get current datetime in ISO format
    formData.append("clockIn", currentDateTime);
    
            this.$API
                .post(this.$InsertAttendance, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.loadData();
                        this.isPopupSuccess = true;

                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        SubmitAttendanceClockOut() {
            const formData = new FormData();
    const currentDateTime = new Date().toISOString(); // Get current datetime in ISO format
    formData.append("clockOut", currentDateTime);
            this.$API
                .post(this.$InsertAttendance, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.loadData();
                        this.isPopupSuccess = true;

                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },

    }

};
</script>

<style scoped>
.calendar {
    font-family: Arial, sans-serif;
    width: 100%;
}

.calendar-header {
    display: flex;
    justify-content: space-between;
}

.day {
    text-align: center;
    width: 14%;
    /* Adjust width to fit 7 days */
    cursor: pointer;
}

.date {
    font-weight: bold;
    border-radius: 65px;
    padding: 5px;
    margin: 2px;
}

.not-current-date {
    background: #EAECF0;
    color: #98A2B3;
}

.day-name {
    color: gray;
}

.current-date {
    background: #175CD3;
    color: white;
}

.selected-date {
    background: #175CD3;
    color: white;
}

.current-day-name {
    color: #175CD3;
}

.selected-day-name {
    color: #175CD3;
}

.calendar-body {
    margin-top: 20px;
}

.time-slot {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.time {
    font-weight: bold;
    width: 20%;
    color: #98A2B3;
    color: var(--Grey-HR, #98A2B3);
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
}

.events {
    width: 80%;
}

.event {
    background-color: #ECFDF3;
    margin-bottom: 5px;
    padding: 5px;
    border-radius: 3px;
    color: #171717;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
}
</style>